/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.RevenueDepartmentResponseDto>
>;
export function request(
  params: API.basics.revenueDepartment.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/revenueDepartment/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
